@import "../../../styles/global.scss";
@import "../../../styles/variables.scss";
@import "../../../styles/mixins/form-search-bar";

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.search-bar__container {
  display: flex;
}

.search-bar-control-group {
  width: 100%;
}

.search-bar__form {
  @include from-search-bar;
  z-index: var(--z-index-form-search-bar, 1);
}

.search-bar__input-container {
  width: 100%;
  position: relative;
  display: flex;
}

.search-bar__button {
  z-index: var(--z-index-guided-pane, 25);
}

.search-bar__cancel {
  margin-left: 12px;
  display: none;
}

.search-bar__cancel--visible {
  @media (max-width: 720px) {
    display: flex;
  }
}

.guided-dropdown {
  width: auto;
}

.qds-control-group-inline {
  width: 100%;
}

.search-bar__input {
  width: 100%;
}

.search-bar__button-container {
  flex-shrink: 0;
}
